export const genericActionResultTypeFields = `  result error_message `
export const mock = 1
